import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ThemeProvider } from "@mui/material/styles";
import { stockTableListTheme } from "@/styles/mui/tableListTheme";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import { Box } from "@mui/material";
import { editStockOnHandList } from "@/fetch/fetchStock";

import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";

export default function StockOnHandEditDialog(props) {
  const {
    open,
    id,
    itemId,
    itemName,
    onHandQty,
    selectReason,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    fetchAll,
  } = props;

  const [formValidation, setFormvalidation] = React.useState({
    reasonIndex: "",
    adjustQty: "",
    radio: "",
    remark: "",
  });

  const [dialogValue, setdialogValue] = React.useState({
    radio: "+",
    textField: "",
    reasonIndex: "",
    remark: " ",
  });

  const handleRadioChange = (event) => {
    setdialogValue((prev) => ({ ...prev, radio: event.target.value }));
  };

  const handleQtyChange = (event) => {
    setdialogValue((prev) => ({
      ...prev,
      textField:
        event.target.value < 0 ? event.target.value * -1 : event.target.value,
    }));
  };

  const handleReasonChange = (event) => {
    setdialogValue((prev) => ({
      ...prev,
      reasonIndex: event.target.value,
    }));
  };

  const handleRemarkChange = (event) => {
    setdialogValue((prev) => ({
      ...prev,
      remark: event.target.value,
    }));
  };

  const handleOnClose = () => {
    setdialogValue({
      radio: "+",
      textField: "",
      reasonIndex: "",
      remark: " ",
    });
    setFormvalidation({
      reasonIndex: "",
      adjustQty: "",
      radio: "",
      remark: "",
    });
    onClose();
  };

  const onSubmit = async () => {
    const reqBody = {
      giveaway_master_item_id: itemId,
      adjust_qty:
        dialogValue.radio !== ""
          ? dialogValue.radio === "+"
            ? +dialogValue.textField
            : -dialogValue.textField
          : dialogValue.textField,
      user_id: id,
      reason_id: selectReason[dialogValue.reasonIndex]?.id,
      remark: dialogValue.remark.trim(),
    };

    const inValid = {
      reasonIndexValid: ["", undefined, null, " "].some(
        (item) => item === dialogValue.reasonIndex
      ),
      remarkValid: ["", undefined, null, 0, " "].some(
        (item) => item === dialogValue.remark && reqBody.reason_id === 999
      ),
      adjustQtyValid: ["", undefined, null, 0, " "].some(
        (item) => item === dialogValue.textField
      ),
      radioValid: ["", undefined, null, 0, " "].some(
        (item) => item === dialogValue.radio
      ),
    };

    setFormvalidation((prev) => ({
      ...prev,
      reasonIndex: inValid.reasonIndexValid ? "必須選擇" : "",
      adjustQty: inValid.adjustQtyValid ? "不能為空值" : "",
      radio: inValid.radioValid ? "不能為空值" : "",
      remark: inValid.remarkValid ? "不能為空值" : "",
    }));

    if (
      inValid.reasonIndexValid ||
      inValid.remarkValid ||
      inValid.adjustQtyValid ||
      inValid.radioValid
    ) {
      return false;
    } else {
      try {
        const { data } = await editStockOnHandList([reqBody]);
        if (data) {
          setSnackMessage("新增成功");
          setSnackSeverity("success");
          setSnackOpen(true);
          fetchAll();
        }
      } catch (err) {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
        setSnackOpen(true);
      } finally {
        handleOnClose();
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleOnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          調整倉儲數量
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <ThemeProvider theme={stockTableListTheme}>
            <Stack>{itemName}</Stack>
            <FormControl error={formValidation.radio}>
              <Box
                sx={{
                  display: "flex",
                  gap: 3,
                  alignItems: "center",
                }}
              >
                <FormLabel id="demo-controlled-radio-buttons-group">
                  調整
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={dialogValue.radio}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel
                    value="+"
                    control={<Radio color="success" />}
                    label="增加"
                  />
                  <FormControlLabel
                    value="-"
                    control={<Radio color="success" />}
                    label="減少"
                  />
                </RadioGroup>
              </Box>
              <FormHelperText>{formValidation.radio}</FormHelperText>
            </FormControl>
            <TextField
              helperText={formValidation.adjustQty}
              label="數量"
              error={!!formValidation.adjustQty}
              type="number"
              value={dialogValue.textField}
              onChange={handleQtyChange}
              inputProps={{ min: 0 }}
            />
            <FormControl error={!!formValidation.reasonIndex} fullWidth>
              <InputLabel id="select-brands-label">原因</InputLabel>
              <Select
                required
                id="brand"
                name="brand"
                label="Brand"
                labelId="select-brands-label"
                value={dialogValue.reasonIndex}
                onChange={handleReasonChange}
              >
                <MenuItem disabled>請選擇</MenuItem>
                {_.map(selectReason, (item, key) => (
                  <MenuItem key={key} value={key}>
                    {item.reason}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formValidation.reasonIndex}</FormHelperText>
            </FormControl>
            <TextField
              value={dialogValue.remark}
              onChange={handleRemarkChange}
              error={!!formValidation.remark}
              id="standard-multiline-static"
              label="備註"
              variant="standard"
              helperText={formValidation.remark}
            />
            <FormControl fullWidth>
              <Stack>
                {dialogValue.radio === "+"
                  ? parseInt(onHandQty) +
                    (dialogValue.textField
                      ? parseInt(dialogValue.textField)
                      : 0)
                  : parseInt(onHandQty) -
                    (dialogValue.textField
                      ? parseInt(dialogValue.textField)
                      : 0)}
              </Stack>
            </FormControl>
          </ThemeProvider>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose}>取消</Button>
        <Button onClick={onSubmit} type="submit">
          新增
        </Button>
      </DialogActions>
    </Dialog>
  );
}
